<template>
  <div class="bg-grey">
    <div class="products">
      <div class="section-title">
        {{ $t('workTitle') }}
      </div>
      <div>
        <div v-for="item in list" :key="item.title" class="item">
          <div class="img-container">
            <img :src="item.icon" class="img">
          </div>
          <div class="title">{{ item.title }}</div>
          <div class="desc">{{ item.desc }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  i18n: {
    messages: {
      en: {
        choosePlanMessage: 'Top up using our escrow account',
        chooseWealthPlan: 'Top Up',
        connect: 'Earn',
        connectMessage: 'Once you invest, sit back, relax and enjoy the returns.',
        invest: 'Lend',
        investMessage: 'Choose the amount and timeframe as per your preference.',
        signUp: 'Sign Up',
        signUpMessage: 'Fill out your personal data. This will be verified within 24 hours.',
        workTitle: 'How it works?',
      },
      id: {
        choosePlanMessage: 'Tentukan rencana pendanaan terbaik sesuai dengan jangka waktu dan jumlah pendanaan yang sesuai keinginan Anda..',
        chooseWealthPlan: 'Pilih Rencana Pendanaan Terbaik',
        connect: 'Pencocokan',
        connectMessage: 'Pendanaan Anda otomatis akan terhubung dengan pihak peminjam. Anda tidak perlu khawatir dan hanya perlu menunggu hingga masa pendanaan selesai.',
        invest: 'Pendanaan',
        investMessage: 'Isi nominal pada akun pendanaan Anda, kemudian masukkan nominal pendanaan dan jangka waktu yang Anda inginkan.',
        signUp: 'Daftar',
        signUpMessage: 'Isi data pribadi Anda dengan informasi lengkap, lalu verifikasi data diri sebelum menyiapkan akun pendanaan Anda.',
        workTitle: 'Bagaimana cara kerjanya?',
      },
    },
  },
  data() {
    return {
      list: [
        {
          title: this.$t('signUp'),
          desc: this.$t('signUpMessage'),
          icon: require('@/assets/image/home/products/search.svg'), // eslint-disable-line global-require
        },
        {
          title: this.$t('invest'),
          desc: this.$t('investMessage'),
          icon: require('@/assets/image/home/products/aim.svg'), // eslint-disable-line global-require
        },
        {
          title: this.$t('chooseWealthPlan'),
          desc: this.$t('choosePlanMessage'),
          icon: require('@/assets/image/home/products/product.svg'), // eslint-disable-line global-require
        },
        {
          title: this.$t('connect'),
          desc: this.$t('connectMessage'),
          icon: require('@/assets/image/home/products/analytics.svg'), // eslint-disable-line global-require
        },
      ],
    }
  },
}
</script>

<style lang="stylus" scoped>
.products {
  overflow: hidden;
  padding: 40px 16px;
  margin: 0 auto;
}

.item {
  min-height: 0;
  text-align: center;
  padding: 16px 0;
}

.works-title {
  text-align: center;
  font-size: 20px;
  padding: 0px 0 20px 0;
}

.img-container {
  position: relative;
  display: inline-block;
  width: 50px;
  height: 50px;
  background: #ffffff;
  border-radius: 100px;
  box-shadow: 0 0px 16px 0 rgba(0, 0, 0, 0.08);
}

.img {
  width: 32px;
  height: 32px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.title {
  font-size: 18px;
  padding: 24px 0 8px 0;
  color: #444;
}

.desc {
  word-wrap: break-word;
  color: #888888;
  line-height: 18px;
  font-size: 14px;
}

.bg-grey {
  background: #f8f8f8;
}
</style>
